module.exports = __webpack_public_path__ + "static/media/CanteenDealDefault.220321f7.png";